import type { ReactNode } from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

/** One 44px project row shared by the workspace switcher and the move picker. */
export function ProjectOptionRow({
  icon,
  label,
  selected,
  onClick,
  disabled = false,
  hint,
}: {
  icon: ReactNode;
  label: string;
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
  /** Short trailing tag such as "Current". */
  hint?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
      className={cn(
        "flex min-h-11 w-full items-center gap-2 rounded-lg px-2.5 py-2 text-sm transition-colors focus-visible:outline-none focus-visible:shadow-glow-sm disabled:cursor-not-allowed disabled:opacity-60",
        selected ? "bg-studio-card text-studio-ink" : "text-studio-muted enabled:hover:bg-studio-card/50 enabled:hover:text-studio-ink"
      )}
    >
      <span className="shrink-0">{icon}</span>
      <span className="min-w-0 flex-1 truncate text-left">{label}</span>
      {hint && <span className="shrink-0 text-[11px] font-medium uppercase tracking-wider text-studio-faint">{hint}</span>}
      {selected && <Check className="h-3.5 w-3.5 shrink-0 text-studio-accent" />}
    </button>
  );
}
